module.exports = __webpack_public_path__ + "static/media/zs.371c0ff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zs.png
// module id = 567
// module chunks = 6